import React from 'react';
import cn from 'classnames';
import _slice from 'lodash/slice';
import Image from 'next/future/image';
import * as PropTypes from 'prop-types';

import styles from './AboutZippia.module.css';

const propTypes = {
  siteMentions: PropTypes.arrayOf(
    PropTypes.shape({
      mention: PropTypes.string,
      source: PropTypes.string,
      image: PropTypes.string,
    })
  ).isRequired,
};

const SiteMention = ({ mentionItem }) => {
  const { mention, source, image } = mentionItem;
  return (
    <div className={styles['mention-container']}>
      <div className={cn('align-items-center', styles['mention-box'])}>
        <p className={styles['mention-quoter']}>{`“${mention}”`}</p>
        {source ? (
          <a href={source} className={cn('d-block position-relative', styles['logo-container'])} target="_blank" rel="noopener noreferrer">
            <Image src={image} className={styles['logo']} alt="Mention Logo" fill />
          </a>
        ) : (
          <span className={cn('d-block position-relative', styles['logo-container'])}>
            <Image src={image} className={styles['logo']} alt="Mention Logo" fill />
          </span>
        )}
      </div>
    </div>
  );
};

class AboutZippia extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      leftArrow: false,
      rightArrow: true,
      dotIndex: 0,
    };
    this.mentionsRef = React.createRef();
    this.mentionsDotsRef = React.createRef();
  }

  moveToIndex = (e, index) => {
    const { dotIndex } = this.state;
    const side = index > dotIndex ? 1 : -1;
    const containerMargin = this.mentionsRef.current.scrollLeft;
    const distance = (this.mentionsRef.current.children[index].offsetLeft - containerMargin) * side;
    this.slideContainer(e, this.mentionsRef, side, distance, 600);
  };

  checkArrowsAndDots = () => {
    const { leftArrow, rightArrow, dotIndex } = this.state;
    const maxScrollLeft =
      this.mentionsRef.current.scrollWidth - this.mentionsRef.current.clientWidth;
    if (
      (this.mentionsRef.current.scrollLeft > 10 && !leftArrow) ||
      (this.mentionsRef.current.scrollLeft < 10 && leftArrow) ||
      (maxScrollLeft < this.mentionsRef.current.scrollLeft + 5 && rightArrow) ||
      (maxScrollLeft > this.mentionsRef.current.scrollLeft + 5 && !rightArrow)
    ) {
      this.setState({
        leftArrow: this.mentionsRef.current.scrollLeft > 10,
        rightArrow: maxScrollLeft > this.mentionsRef.current.scrollLeft + 5,
      });
    }

    const mentionWidth = this.mentionsRef.current.children[0].clientWidth;
    const left = this.mentionsRef.current.scrollLeft + 10;
    const itemStart = Math.round(left / mentionWidth);
    if (itemStart !== dotIndex) {
      this.setState({
        dotIndex: itemStart,
      });
    }
  };

  slideContainer = (e, ref, side, distance, duration) => {
    e.preventDefault();
    e.stopPropagation();
    const container = ref.current;
    const start = container.scrollLeft;
    const change = side * distance;
    const startDate = +new Date();

    const easeInOutQuad = (t, b, c, d) => {
      t /= d / 2;
      if (t < 1) return (c / 2) * t * t + b;
      t--;
      return (-c / 2) * (t * (t - 2) - 1) + b;
    };

    const animateScroll = () => {
      const currentDate = +new Date();
      const currentTime = currentDate - startDate;
      container.scrollLeft = parseInt(easeInOutQuad(currentTime, start, change, duration));
      if (currentTime < duration) {
        requestAnimationFrame(animateScroll);
      }
    };
    animateScroll();
  };

  render() {
    const { siteMentions } = this.props;
    const { dotIndex, leftArrow, rightArrow } = this.state;
    const isMobileView = window && window.innerWidth <= 768;

    return (
      <section className="section">
        <div className={styles['site-mentions-sec']}>
          <div className={`container ${styles['mentions-outer-container']}`}>
            {leftArrow && (
              <span
                className="prevImg d-none d-lg-block"
                onClick={(e) => this.moveToIndex(e, dotIndex - 1)}
              />
            )}
            {rightArrow && (
              <span
                className="nextImg d-none d-lg-block"
                onClick={(e) => this.moveToIndex(e, dotIndex + 1)}
              />
            )}
            <div className={styles['site-mentions-container-cutoff']}>
              <div
                id="mentions-container"
                className={styles['site-mentions-container']}
                ref={this.mentionsRef}
                onScroll={this.checkArrowsAndDots}
              >
                {siteMentions.map((mention) => (
                  <SiteMention key={mention.mention} mentionItem={mention} />
                ))}
              </div>
            </div>
          </div>

          <div
            id="mention-dots-container"
            className={`${styles['site-mentions-dots']} container noSelect`}
            ref={this.mentionsDotsRef}
          >
            {_slice(
              siteMentions,
              0,
              isMobileView ? siteMentions.length : siteMentions.length - 2
            ).map((mention, index) => (
              <div
                key={mention.mention}
                className={`${styles['carousel-dot']} ${
                  index === dotIndex ? styles['carousel-dot-active'] : ''
                }`}
                onClick={(e) => {
                  this.moveToIndex(e, index);
                }}
              />
            ))}
          </div>
        </div>
      </section>
    );
  }
}

AboutZippia.propTypes = propTypes;

export default AboutZippia;
